import {
  SubscriptionsInput,
  SubscriptionsOutput,
} from "@/interfaces/subscriptions";
import { BaseService } from "./BaseService";

export class SubscriptionsService extends BaseService<
  SubscriptionsInput,
  SubscriptionsOutput
> {
  constructor() {
    super();
    this.path = "subscriptions";
  }

  async changePlan(subscriptionInput: SubscriptionsInput) {
    return this.request(this.path, {
      method: "PUT",
      body: JSON.stringify(subscriptionInput),
    }) as Promise<SubscriptionsOutput>;
  }
}
